<script setup lang="ts">
import PlatformHeader from '~/components/platform/PlatformHeader.vue'

const {locale} = useI18n()
useHead({htmlAttrs: {lang: locale}})
</script>

<template>
  <div class="min-h-screen flex flex-col bg-default">
    <PlatformHeader/>
    <main id="main" class="flex-1">
      <slot/>
    </main>
  </div>
</template>
